// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLightBulb2_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.952 21.564H13.373V20.3999L15.4036 18.3469C15.7988 17.9445 16.1201 17.6012 16.3676 17.3173L16.3686 17.3162C16.6211 17.0348 16.8016 16.7752 16.9135 16.5374L16.914 16.5363C17.0319 16.2936 17.091 16.0336 17.091 15.755C17.091 15.4147 16.9944 15.1792 16.8179 15.0279L16.815 15.0254C16.6402 14.8636 16.3957 14.777 16.069 14.777C15.7536 14.777 15.4606 14.8435 15.1888 14.9759L15.1869 14.9768C14.9101 15.1046 14.62 15.2903 14.3169 15.5357L14.2402 15.5978L13.3554 14.5335L13.4296 14.4693C13.7587 14.1851 14.1284 13.9388 14.5383 13.73C14.9674 13.5079 15.505 13.4 16.146 13.4C16.6634 13.4 17.112 13.4936 17.4884 13.6854C17.8703 13.8689 18.1674 14.1305 18.3759 14.4703C18.5848 14.803 18.688 15.1847 18.688 15.612C18.688 16.051 18.6009 16.4579 18.4255 16.8315C18.2519 17.1938 18 17.558 17.6724 17.9228C17.3548 18.2774 16.9752 18.6606 16.5338 19.0725L15.4013 20.165H18.952V21.564Z" class="svg-bg"/>
  <path d="M17 2H15V7H17V2ZM32 19H27V17H32V19ZM5 17V19H0V17H5ZM20 30V28H12V30H20Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M20 25.0018C22.6779 23.571 24.5 20.7483 24.5 17.4999C24.5 12.8055 20.6944 8.99994 16 8.99994C11.3056 8.99994 7.5 12.8055 7.5 17.4999C7.5 20.7483 9.32211 23.571 12 25.0018V26H20V25.0018ZM22.5 17.4999C22.5 21.0898 19.5899 23.9999 16 23.9999C12.4101 23.9999 9.5 21.0898 9.5 17.4999C9.5 13.9101 12.4101 10.9999 16 10.9999C19.5899 10.9999 22.5 13.9101 22.5 17.4999Z" class="svg-bg"/>
  <path d="M5.39331 5.97925 8.92884 9.51478 7.51463 10.929 3.9791 7.39346 5.39331 5.97925ZM26.6063 5.97911 23.0708 9.51465 24.485 10.9289 28.0205 7.39333 26.6063 5.97911Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLightBulb2 is a generated icon component.
 */
let IconMedLightBulb2 = IconMedLightBulb2_1 = class IconMedLightBulb2 extends IconBaseElement {
    render() {
        return html `${IconMedLightBulb2_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLightBulb2.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconMedLightBulb2 = IconMedLightBulb2_1 = __decorate([
    customElement('zui-icon-med-light-bulb-2')
], IconMedLightBulb2);
export { IconMedLightBulb2 };
